<template>
    <div class="stage-tabs">
        <div class="tabs">
            <div class="tab"
                 v-for="(stage, id) in stages" :key="id">
                <a href="#"
                   @click.prevent="changeTab(id)"
                   :style="`background: ${stage.color}`"
                   :class="{active: selected === id}">
                   <span class="num" :style="`color: ${stage.color}`">{{ stage.number }}</span>
                    {{ stage.name }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StageTabs",
    emits: ['change'],
    props: {
        modelValue: {
            type: [String, Number],
        },
        stages: {
            type: [Array, Object],
        }
    },

    data(){
        return {
            selected: null,
        }
    },

    methods: {
        changeTab(id){
            this.selected = id;
            this.$emit('update:modelValue', id);
            this.$emit('change', id);
            console.log('click', id);
        }
    },

    mounted() {
        this.selected = this.modelValue;
    }

}
</script>

<style lang="scss" scoped>
.tabs{
    display: flex;
}
.tab{
    flex: 1 1 0px;
    background: black;

    a{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.6rem 0.4rem;
        font-weight: $font-weight-bolder;
        text-align: center;
        color: white;
        font-size: 1.3rem;
        text-transform: uppercase;
        text-decoration: none;
        opacity: 0.5;
        transition: opacity .3s;

        &:hover, &.active{
            opacity: 1;
        }

        .num{
            background: white;
            width: 1.3rem;
            height: 1.3rem;
            flex: 0 0 1.3rem;
            border-radius: 50%;
            margin-right: 0.3rem;
            font-size: 0.8em;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
